// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Nn5c","label":"Category_label__1PKEQ","content":"Category_content__3zBtP","header":"Category_header__XvwKP","location":"Category_location__3P4UI"};